// extracted by mini-css-extract-plugin
export default {"closeButton":"CloseButton_closeButton__ILNA2","closeButtonAllyLabel":"CloseButton_closeButtonAllyLabel__0+N9S"};